import * as THREE from 'three';
import { GameScene } from '../scenes/GameScene';
import { BaseInputController } from './BaseInputController';
import { DPadInputController } from './DPadInputController';
import { KeyboardInputController } from './KeyboardInputController';
import { TouchInputController } from './TouchInputController';

export interface InputControllerOptions {
  useDPad?: boolean;
  useKeyboard?: boolean;
  useTouch?: boolean;
}

export class InputControllerConfig {
  private controllers: BaseInputController[] = [];
  private options: InputControllerOptions;

  constructor(camera: THREE.PerspectiveCamera, gameScene: GameScene, options: InputControllerOptions = {}) {
    this.options = {
      useDPad: true,
      useKeyboard: true,
      useTouch: true,
      ...options
    };

    this.initializeControllers(camera, gameScene);
  }

  private initializeControllers(camera: THREE.PerspectiveCamera, gameScene: GameScene): void {
    if (this.options.useDPad) {
      this.controllers.push(new DPadInputController(camera, gameScene));
    }
    if (this.options.useKeyboard) {
      this.controllers.push(new KeyboardInputController(camera, gameScene));
    }
    if (this.options.useTouch) {
      this.controllers.push(new TouchInputController(camera, gameScene));
    }
  }

  public update(deltaTime: number): void {
    this.controllers.forEach(controller => controller.update(deltaTime));
  }

  public dispose(): void {
    this.controllers.forEach(controller => controller.dispose());
    this.controllers = [];
  }

  public setOptions(options: InputControllerOptions): void {
    // Store camera and gameScene from first controller if it exists
    const firstController = this.controllers[0];
    const camera = firstController?.getCamera();
    const gameScene = firstController?.getGameScene();

    // Dispose of all current controllers
    this.dispose();

    // Update options
    this.options = {
      ...this.options,
      ...options
    };

    // Reinitialize controllers with new options if we have the required dependencies
    if (camera && gameScene) {
      this.initializeControllers(camera, gameScene);
    }
  }
} 